<template>
  <div class="wys_container">
    <van-popup v-model="popShow" :style="{ background: 'transparent' }">
      <div class="pop">
        <div class="pop_title">确认合并</div>
        <div class="pop_content">
          <p class="m_box">1.请确认已阅读《友邻少年账号合并协议》</p>
          <p class="m_box">2.您选择的登录账号为：</p>
          <div class="m_box_sort">
            <p>手机号：{{ popObj.mobile || '-' }}</p>
            <p>友邻少年ID：{{ popObj.userId }}</p>
            <p>
              会员权益：{{ popObj.vipName }}
              <span v-if="popObj.vipStartDate">（{{ popObj.vipStartDate }}-{{ popObj.vipEndDate }}）</span>
            </p>
            <p>课程权益：{{ popObj.coursePrivilegeCount }}项</p>
            <p>总学习时长：{{ popObj.learnTimeMin }}分钟</p>
            <p>账户{{ integralName }}余额：{{ popObj.creditAvailable || 0 }}</p>
          </div>
          <p class="m_box">
            3.账号合并成功后，【ID：{{ unChoose.userId }}】将会作 废，且该账号下的学习数据也将会作废。
          </p>
          <p class="m_box" v-if="changeType === 'ACC_WX_BOTH'">
            4.合并账号后,手机号将和微信解除绑定,可登录APP后,点击【个人资料-绑定微信】进行绑定
          </p>
        </div>
        <div class="flexbox btn_group">
          <div class="flexbox" @click="$emit('popClose', false)">取消</div>
          <div class="flexbox" @click="$emit('popSure')">确认</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
Vue.use(Popup)
import { mapGetters } from 'vuex'
import { integralName } from '@/pages/config'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    popObj: {
      type: Object,
      default() {
        return {}
      },
      require: true
    }
  },
  data() {
    return { integralName }
  },
  computed: {
    ...mapGetters('acount', ['unChoose', 'changeType']),
    popShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('popClose', value)
      }
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.pop {
  background-color: #fff;
  border-radius: 0.16rem;
  width: 6.4rem;
  .m_box {
    margin-top: 0.16rem;
  }
  .m_box_sort {
    padding-left: 0.22rem;
    p {
      margin-top: 5px;
    }
  }
  .pop_content {
    font-size: 0.28rem;
    color: rgba(0, 0, 0, 0.5);
    padding: 0 0.32rem;
  }
  .pop_title {
    text-align: center;
    font-size: 0.34rem;
    font-weight: 600;
    padding: 0.48rem 0;
  }
  .btn_group {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 0.34rem;
    margin-top: 0.48rem;
    div {
      flex: 1;
      text-align: center;
      height: 1.12rem;
      justify-content: center;
    }
    div:last-child {
      color: #00b25a;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
